@if (customer) {
    <label class="m-0 p-0 pe-3">
        <div [style.background-image]="customer.icon | safeBgUrl" class="ca-logo"></div>
        @if (Functionalities.CustomerProjectsManage | hasFunctionality) {
            <input (change)="uploadLogo($event)" hidden type="file" />
        }
    </label>
}
